import { render, staticRenderFns } from "./VerPersona.vue?vue&type=template&id=73e2a5c4&"
import script from "./VerPersona.vue?vue&type=script&lang=js&"
export * from "./VerPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports